import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import noop from 'lodash/noop';
import { Text, Icon } from 'roo-ui/components';
import AppLink from 'components/AppLink';

const StyledBackLink = styled(AppLink)`
  color: ${themeGet('colors.greys.steel')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
`;

const BackLink = ({ to, label, onClick }) => {
  return (
    <StyledBackLink to={to} onClick={onClick} data-testid="back-link">
      <Icon name="chevronLeft" color="greys.charcoal" size={24} mr={2} title="Back to search results" />
      <Text fontSize="base" display={['none', 'block']} data-testid="not-phone-label">
        {label}
      </Text>
      <Text fontSize="base" display={['block', 'none']} data-testid="phone-label">
        Back to results
      </Text>
    </StyledBackLink>
  );
};

BackLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

BackLink.defaultProps = {
  onClick: noop,
};

export default BackLink;
